<template>
    <div class="container">
        <div class="container">
            <div class="top">
                <img style="width: 100vw; height: 61.3vw" src="../assets/jifen_bg.webp" />
                <div class="title">
                    积分兑换
                </div>
                <div @click="back" style="width: 16vw; height: 16vw; position: absolute; display: flex; align-items: center; top: 2vw; left: 2vw">
                    <img style="width: 10vw; height: 7.93vw;" src="../assets/back.png" />
                </div>

                <img style="width: 8vw; height: 8vw; position: absolute; top: 40vw; left: 8vw" src="../assets/jifen.webp" />
                <span style="position: absolute; top: 40vw; left: 17vw; font-size: 26px; font-weight: 500;">{{ user_score.toFixed(2) }}</span>
            </div>

            <div style="display: flex; flex-direction: row; flex-wrap: wrap; background-color: white; padding: 2vw; margin-top: -16vw; justify-content: center;">
                <div style="width: 28vw; height: 30vw; background-color: #FDF9FF; margin: 1.2vw; border-radius: 16px; border: 1px #C1C2FF solid; display: flex; align-items: center; flex-direction: column;" v-for="item in withdrawList" :key="item.id">
                    <span style="font-size: 22px; font-weight: 500; color: #7678FF; margin-top: 3vw;">¥{{ item.add_money }}</span>
                    <div style="display: flex; flex-direction: row; font-size: 14px; color: #444; margin-top: 2vw;">
                        <img style="width: 4vw; height: 4vw; margin-right: 2px;" src="../assets/jifen.webp" />
                        <!-- <span style="font-size: 14px;color: #333; margin-top: 4vw;">{{ item.need_score }}积分</span> -->

                        {{ item.need_score }}积分
                    </div>
                    <div @click="exchange(item)" style="display: flex; width: 20vw; height: 6vw; margin-top: 2vw; color: #7678FF; align-items: center; justify-content: center; border: 1px solid #7678FF; border-radius: 4vw;">
                        兑换
                    </div>
                </div>
            </div>
         
        </div>

    </div>
</template>


<script>
import axios from 'axios';
import { prefix, prefix_dev, userWithdrawList, userFinance } from '../url';
import ProfitHelper from '../ProfitHelper';

export default ({
    data() {
        return {
            urlPrefix: prefix,
            head: {
                version: '',
                edition: '',
                aps: '',
                Authorization: '',
                os: 1,
            },

            withdrawList: [],
            user_score: 0.00
        };
    },

    created() {
        this.formatUrlParams();
    },

    methods: {
        formatUrlParams() {
            if (localStorage.getItem('is_dev') == 'yes') {
                this.urlPrefix = prefix_dev;
            }
            this.head.version = localStorage.getItem('version');
            this.head.edition = localStorage.getItem('edition');
            this.head.aps = localStorage.getItem('aps');
            this.head.Authorization = localStorage.getItem('Authorization');

            this.user_score = parseFloat(localStorage.getItem("user_score"));
            this.getWithdrawList();
        },

        back() {
            const backUrl = localStorage.getItem('is_dev') == 'yes' ? '/profit-dev?version=' : '/profit?version=';
            window.location.href = backUrl + this.head.version + '&edition=' + this.head.edition + "&aps=" + this.head.aps + "&Authorization=" + this.head.Authorization;
        },

        getWithdrawList() {
            const url = this.urlPrefix + userWithdrawList + '?money_type=user_score';
            axios.get(url, {
                headers: this.head,
            }).then(res => {
                const data = res.data.data;
                const list = data.list;
                this.withdrawList = list;
                // console.log('on value withdraw list si - - - ----->', res.data, this.urlPrefix);
            }).catch(err => { });
        },

        exchange(item) {
            if (this.user_score < parseInt(item.need_score)) {
                alert('积分不足！');
                return;
            }
            if (item.state == '2') {
                alert('此档位暂兑换次数已超限！')
                return;
            }

            localStorage.setItem("ITEM_ID", item.id);
            localStorage.setItem('ITEM_ADD_MONEY', item.add_money);
            window.location.href = '/profit-account';
        }
    }
})
</script>



<style scoped>
.container {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: rgb(239, 238, 246);
}
.loading {
    width: 100vw;
    height: 100vh;
    position: absolute;
    background-color: white;
}

.top {
    width: 100vw;
    height: 74.6vw;
    display: flex;
}
.title {
    position: absolute;
    top: 6vw;
    width: 100%;
    text-align: center;
    font-size: 18px;
}
</style>